import { useState } from 'react';
import { Box, Typography, Snackbar, Alert } from '@mui/material';
import TransferForm from '../components/transactions/TransferForm';

const mockAccounts = [
  { id: 1, name: 'Savings Account 1', number: '1234567890' },
  { id: 2, name: 'Savings Account 2', number: '9876543210' },
];
const mockBeneficiaries = [
  { id: 1, name: 'Alice Smith', accountNumber: '111122223333' },
  { id: 2, name: 'Bob Johnson', accountNumber: '444455556666' },
];

const ThirdPartyTransfer: React.FC = () => {
  const [fromAccount, setFromAccount] = useState('');
  const [beneficiary, setBeneficiary] = useState('');
  const [amount, setAmount] = useState('');
  const [remarks, setRemarks] = useState('');
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!fromAccount || !beneficiary || !amount || isNaN(Number(amount)) || Number(amount) <= 0) {
      setError('Please fill all fields correctly.');
      return;
    }
    setSuccess(true);
    setFromAccount('');
    setBeneficiary('');
    setAmount('');
    setRemarks('');
  };

  return (
    <Box sx={{ p: 3, maxWidth: 500, mx: 'auto' }}>
      <Typography variant="h4" mb={2}>Third Party Transfer</Typography>
      
      <TransferForm
        fromAccount={fromAccount}
        setFromAccount={setFromAccount}
        beneficiary={beneficiary}
        setBeneficiary={setBeneficiary}
        amount={amount}
        setAmount={setAmount}
        remarks={remarks}
        setRemarks={setRemarks}
        onSubmit={handleSubmit}
        accounts={mockAccounts}
        beneficiaries={mockBeneficiaries}
      />
      
      <Snackbar open={!!error} autoHideDuration={4000} onClose={() => setError('')}>
        <Alert severity="error" onClose={() => setError('')} sx={{ width: '100%' }}>
          {error}
        </Alert>
      </Snackbar>
      <Snackbar open={success} autoHideDuration={4000} onClose={() => setSuccess(false)}>
        <Alert severity="success" onClose={() => setSuccess(false)} sx={{ width: '100%' }}>
          Transfer successful!
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default ThirdPartyTransfer; 